import { render, staticRenderFns } from "./CreatorRequestView.vue?vue&type=template&id=22deda60&"
import script from "./CreatorRequestView.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports